
/* eslint-disable react/prop-types */
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function ProtectedRoute({ Component, user, ...rest }) {
  return (
    <Route
      {...rest}
      render={props => (
        user
          ? <Component {...props} />
          : <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
      )}
    />
  );
}

ProtectedRoute.propTypes = {
  Component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  user: PropTypes.object,
};

ProtectedRoute.defaultProps = {
  user: null,
};

/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/components/protected_route/protected_route.jsx